import { createPaginatedNetworkRequestHook } from '@/utils/createPaginatedNetworkRequestHook'

import { PaginatedList } from '@/lib/core/interfaces/common.types'
import { PaginationPayload } from '@/lib/core/components/Pagination/Pagination'

import { useNetworkMutation } from '@/lib/utils/request'

import { AssetTag } from '../components'

const baseUrl = 'v1/tags'

export type TagsResponse = PaginatedList<AssetTag>

export type AddTagPayload = {
  name: string
  color: string
}

export type AddTagResponse = AssetTag

export type EditTagPayload = {
  params: {
    id: number
  }
  name?: string
  color?: string
}

export type EditTagResponse = AssetTag

export type DeleteTagPayload = {
  params: {
    id: number
  }
}

export type DeleteTagResponse = void

export type AssignTagsPayload = {
  params: {
    asset_id: number
  }
  data: {
    tag_ids: number[]
  }
}

export type AssignTagsResponse = {
  success: boolean
}

// API hooks
export const useTags = createPaginatedNetworkRequestHook<AssetTag, PaginationPayload, TagsResponse>(
  `${baseUrl}/`,
)

export const useAddTag = () =>
  useNetworkMutation<AddTagResponse, AddTagPayload>({
    url: `${baseUrl}/`,
    method: 'post',
  })

export const useEditTag = () =>
  useNetworkMutation<EditTagResponse, EditTagPayload>({
    url: `${baseUrl}/\${params.id}/`,
    method: 'patch',
  })

export const useDeleteTag = () =>
  useNetworkMutation<DeleteTagResponse, DeleteTagPayload>({
    url: `${baseUrl}/\${params.id}/`,
    method: 'delete',
  })

export const useAssignTags = () =>
  useNetworkMutation<AssignTagsResponse, AssignTagsPayload>({
    url: `${baseUrl}/assets/\${params.asset_id}/`,
    method: 'post',
  })
